import { Injectable } from '@angular/core';
import { ApiService, Secretaria, Secretario, SolicitacaoFerias } from '../../api.service';
import { ServicoFormatacao } from '../../shared/servico-formatacao';
import {
  calcularDiasPortaria,
  mascararPeriodoAquisitivo,
  nomeArquivoPortaria,
  periodoAquisitivoValido
} from './regras-portaria-ferias';

@Injectable({ providedIn: 'root' })
export class ServicoPortariaFerias {
  constructor(
    private readonly api: ApiService,
    private readonly servicoFormatacao: ServicoFormatacao
  ) {}

  listarSecretarias(empregadorId: string, incluirInativos = false) {
    return this.api.listarSecretarias(empregadorId, incluirInativos);
  }

  salvarSecretaria(secretaria: Secretaria) {
    return this.api.salvarSecretaria(secretaria);
  }

  excluirSecretaria(id: string) {
    return this.api.excluirSecretaria(id);
  }

  listarSecretarios(empregadorId: string) {
    return this.api.listarSecretarios(empregadorId);
  }

  salvarSecretario(secretario: Secretario) {
    return this.api.salvarSecretario(secretario);
  }

  excluirSecretario(id: string) {
    return this.api.excluirSecretario(id);
  }

  decidirFerias(
    id: string,
    deferida: boolean,
    parecer?: string,
    extra?: { secretariaId?: string; periodoAquisitivo?: string; dataInicio?: string; dataFim?: string }
  ) {
    return this.api.decidirFeriasGerencial(id, deferida, parecer, extra);
  }

  baixarPortariaObservable(id: string) {
    return this.api.baixarPortariaFerias(id);
  }

  baixarBlob(blob: Blob, nomeArquivo: string) {
    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/msword' }));
    const ancora = document.createElement('a');
    ancora.href = url;
    ancora.download = nomeArquivo;
    ancora.click();
    window.URL.revokeObjectURL(url);
  }

  nomeArquivo(numero?: number, ano?: number) {
    return nomeArquivoPortaria(numero, ano);
  }

  novaSecretaria(empregadorId = ''): Secretaria {
    return { empregadorId, nome: '', ativo: true };
  }

  novoSecretario(empregadorId = ''): Secretario {
    return { empregadorId, secretariaId: '', nome: '' };
  }

  mascararPeriodoAquisitivo(valor: string) {
    return mascararPeriodoAquisitivo(valor);
  }

  periodoAquisitivoValido(valor?: string) {
    return periodoAquisitivoValido(valor);
  }

  calcularDias(inicio?: string, fim?: string) {
    return calcularDiasPortaria(inicio, fim);
  }

  formatarData(valor?: string) {
    return this.servicoFormatacao.formatarDataIso(valor);
  }

  dataHojeIso() {
    return this.servicoFormatacao.dataParaIsoLocal(new Date());
  }

  dataHojeExtenso() {
    return this.servicoFormatacao.formatarDataExtenso(new Date());
  }

  secretarioDaSecretaria(secretarios: Secretario[], secretariaId?: string) {
    return secretarios.find(item => item.secretariaId === secretariaId);
  }

  nomeSecretaria(secretarias: Secretaria[], secretariaId?: string) {
    return secretarias.find(item => item.id === secretariaId)?.nome || '';
  }

  temPortaria(item?: SolicitacaoFerias | null) {
    return !!item?.portariaNumero && !!item?.portariaAno;
  }
}
